// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"333":"28d9b1f8","640":"30227d75"}[chunkId] + ".css";
};